// src/constants/licenseTiers.js
//
// Single source of truth for license-tier values + display labels.
// Values must match aiprime.license_tiers.tier_code exactly.
//
// Org roles live separately in orgRoles.js — different axis.
// Project roles live in projectRoles.js — different axis again.
// All three axes compose; min-of-axes wins per REQ-046.

export const LICENSE_TIER_OPTIONS = [
  { value: "ANALYST",         label: "Analyst" },
  { value: "TEAM",            label: "Team" },
  { value: "ENTERPRISE_SITE", label: "Enterprise Site" },
  { value: "CONSUMER_VIEWER", label: "Consumer/Viewer" },
  // FIELD — the only tier granting can_route, and the reason REM-277 existed.
  //
  // Both endpoints that take a tier_code have accepted this value since long
  // before the tier was seeded: POST /api/v1/platform/orgs/:orgId/seats and
  // POST /api/v1/admin/orgs/invites both validate against aiprime.license_tiers
  // rather than against any list in this file. THIS ARRAY WAS THE ONLY THING
  // STOPPING IT — it feeds both dropdowns (OrgSeatsPanel for the pool,
  // OrgInviteForm for the assignment), so a tier absent here cannot be named by
  // an admin even though the server would have taken it.
  //
  // ITS PRICE IS STILL 0.00 AND VISIBLY UNSET. 097_field_tier_verify.sql fails
  // if that changes. Selectable is not the same as priced, and this line makes
  // the first true without making the second.
  { value: "FIELD",           label: "Field" },
];

export const LICENSE_TIER_LABEL = Object.fromEntries(
  LICENSE_TIER_OPTIONS.map(t => [t.value, t.label])
);

// Default tier for new seat assignments. Pick whichever matches
// "what most users get on a fresh org" — likely ANALYST for paid pilots.
export const DEFAULT_LICENSE_TIER = "ANALYST";